
const digest = '67d3ca4eb26868ae12c49fb57322663c12ffbfc41d14d1aef1f36e8b6fe124a0';
const classes = {"wrapper":"_wrapper_1iejg_1","quickAdjustmentWrapper":"_quickAdjustmentWrapper_1iejg_9","header":"_header_1iejg_15","button":"_button_1iejg_19"};
const css = `._wrapper_1iejg_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  width: 100%;
}

._quickAdjustmentWrapper_1iejg_9 {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._quickAdjustmentWrapper_1iejg_9 ._header_1iejg_15 {
  display: none;
}

._button_1iejg_19 {
  display: flex;
  margin-left: auto;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  